export const BACKSPACE = 8;
export const DELETE = 46;
export const UP = 38;
export const DOWN = 40;
export const ENTER = 13;
